










































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CollapsableItem } from '../../../models/CollapsableMenu';

@Component
export default class CollapsableCoursesSection extends Vue {
    @Prop() private item!: CollapsableItem;
    private searchQuery: string = '';

    get availableCourses(): any[] {
        if (!this.item.items) return [];
        return this.item.items.filter(
            item => item.isCourse && item.title && item.title.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    }
    get displayedCourses(): any[] {
        return this.availableCourses.filter(item => item.status !== 'completed').slice(0, 5);
    }

    get numCourses(): number {
        return this.availableCourses.length;
    }

    get linkTitle(): string {
        if (!this.item.introLinkTitle) return '';
        return this.item.introLinkTitle.replace('{0}', this.numCourses.toString());
    }

    private formatDuration(duration: string): string {
        return duration ? `${Number(duration) / 60} min` : '';
    }

    private formatDate(date: string): string {
        return new Date(date).toISOString().split('T')[0];
    }
}
